// Rendu dynamique des onglets dans la section "Mes Expériences"
import { useState } from 'react';

function VoirPlus() {
    const [isVisible, setIsVisible] = useState(false);
    
    return (
    <div>
      {isVisible && 
        <div>
            <p><strong>Dates :</strong> Octobre 2024 - Août 2026</p>
            <p><strong>Poste :</strong> Responsable Système d'Information</p>
            <p><strong>Compétences développées :</strong></p>
            <p>
                <ul>
                    <li>Mise en place de serveur Debian</li>
                    <li>Intégration d'une solution drive internalisée</li>
                    <li>Développement de scripts Bash</li>
                    <li>Gestion de bases de données : MySQL, PostgreSQL</li>
                    <li>Mise en place de solution sous Docker</li>
                    <li>Architecture Docker</li>
                    <li>mise en place de serveur</li>
                    <li>maintenance active et réactive</li>
                    <li>Gestion et d'administration de systèmes informatiquese sous Linux</li>
                    <li>Mise en place documentation Ebios RM</li>
                </ul>
            </p>
            <p><strong>Dates :</strong> Septembre 2026 - Novembre 2026</p>
            <p><strong>Poste :</strong> Ingénieur de projet informatique spécialisé en cybersécurité</p>
            <p><strong>Compétences développées :</strong></p>
            <p>
                <ul>
                    <li>Mise en place de serveur Debian</li>
                    <li>Administration de systèmes Linux</li>
                    <li>Gestion de bases de données : MySQL, PostgreSQL</li>
                    <li>Mise en place de solution sous Docker</li>
                    <li>Architecture Docker</li>
                    <li>mise en place de serveur</li>
                    <li>maintenance active et réactive</li>
                    <li>Mise en place d'un serveur Proxmox</li>
                </ul>
            </p>
        </div>
    }
      <button onClick={() => setIsVisible(!isVisible)} className="MoreInfo">
        Voir plus d'informations
      </button>
    </div>
  )
}

const OngletsExp = () => {
    const [activeTab, setActiveTab] = useState('entreprise1');

    const handleTabClick = (tab) => {
        setActiveTab(tab);
    };

    return (
        <div className="experiences-container glass-effect">
            <div className="tabs">
                <button
                    className={`tab ${activeTab === 'entreprise1' ? 'active' : ''}`}
                    data-tab="entreprise1"
                    onClick={() => handleTabClick('entreprise1')}>
                    Lens Informatique
                </button>
                <button
                    className={`tab ${activeTab === 'entreprise2' ? 'active' : ''}`}
                    data-tab="entreprise2"
                    onClick={() => handleTabClick('entreprise2')}
                >
                    Coming web
                </button>
                <button
                    className={`tab ${activeTab === 'entreprise3' ? 'active' : ''}`}
                    data-tab="entreprise3"
                    onClick={() => handleTabClick('entreprise3')}
                >
                    IPCZEN
                </button>
                <button
                    className={`tab ${activeTab === 'entreprise4' ? 'active' : ''}`}
                    data-tab="entreprise4"
                    onClick={() => handleTabClick('entreprise4')}
                >
                    Solecooler
                </button>
            </div>

            {activeTab === 'entreprise1' && (
                <div className="tab-content active" id="entreprise1">
                    <div className="company-info">
                        <h3>Nom : Lens Informatique</h3>
                        <p><strong>Dates :</strong> Mai 2021 - Août 2021</p>
                        <p><strong>Poste :</strong> Développeur FULL STACK</p>
                        <p><strong>Compétences développées :</strong> HTML, CSS, JavaScript, MariaDB, PHP, SQL</p>
                    </div>
                </div>
            )}

            {activeTab === 'entreprise2' && (
                <div className="tab-content active" id="entreprise2">
                    <div className="company-info">
                        <h3>Nom : Coming-web</h3>
                        <p><strong>Dates :</strong> Août 2021 - Septembre 2022</p>
                        <p><strong>Poste :</strong> Développeur FULL STACK</p>
                        <p><strong>Compétences développées :</strong> HTML, CSS, JavaScript, JQUERY</p>
                    </div>
                </div>
            )}

            {activeTab === 'entreprise3' && (
                <div className="tab-content active" id="entreprise3">
                    <div className="company-info">
                        <h3>Nom : IPCZEN</h3>
                        <p><strong>Dates :</strong> Décembre 2022 - Avril 2023</p>
                        <p><strong>Poste :</strong> Développeur FULL STACK</p>
                        <p><strong>Compétences développées :</strong> HTML, JavaScript, PHP</p>
                    </div>
                </div>
            )}

            {activeTab === 'entreprise4' && (
                <div className="tab-content active" id="entreprise4">
                    <div className="company-info">
                        <h3>Nom : Solecooler</h3>
                        <p><strong>Dates :</strong> Novembre 2023 - Octobre 2024</p>
                        <p><strong>Poste :</strong> Développeur FULL STACK</p>
                        <p><strong>Compétences développées :</strong> HTML, CSS, JavaScript, PHP, Symfony, Bash, SQL</p>
                        <VoirPlus/>
                    </div>
                </div>
            )}

            </div>
    );
};

export default OngletsExp;

            